import CuantoLogoDark from "./CuantoLogoDark";
import CuantoLoveFooter from "./CuantoLoveFooter";

export { CuantoLoveFooter, CuantoLogoDark };
